// HMRC production checklist: signpost unsupported sources/end-of-year to compatible software,
// and tax calculation to the customer's HMRC Personal / Business Tax Account. The ONE HMRC
// account link used everywhere — gov.uk/sign-in-hmrc-online-services (used previously) is a 404.
export const COMPATIBLE_SOFTWARE_URL =
  'https://www.gov.uk/guidance/find-software-thats-compatible-with-making-tax-digital-for-income-tax'
export const HMRC_ONLINE_ACCOUNT_URL = 'https://www.gov.uk/log-in-register-hmrc-online-services'

// Shown on the receipt when the post-submit retrieve fails — the submission itself succeeded.
export const RETRIEVE_WARNING =
  'Your submission was accepted by HMRC, but we could not retrieve the figures HMRC now holds. You can check them in your HMRC online account.'
